
export class SDEnumeration {
    className: string;
    value: string;
}
